import { BACKEND_URL_V1, deletee } from "lib/Api";
import { FMSError } from "types/Error";

export const deleteStaffFood = async (
  stockId: string
): Promise<FMSError | null> => {
  try {
    const response = await deletee(`${BACKEND_URL_V1}/staffFood/${stockId}/`);
    if (Math.floor(response.status / 100) === 2) {
      return null;
    }
  } catch (err) {
    return new FMSError("Something went wrong");
  }
  return new FMSError("Something went wrong");
};
